import Vue from 'vue'
import App from './App.vue'

import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLodash from 'vue-lodash'
import i18n from './locales/i18n'
import VueSweetalert2 from 'vue-sweetalert2';

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import './assets/css/styles.css';

import VueGtag from "vue-gtag";
import router from './router'
// import Session from "@/session/Session.js";

window._ = require('lodash');
moment.locale('es')

/**
<!-- Global site tag (gtag.js) - Google Analytics -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-MH61P4MVJ0"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-MH61P4MVJ0');
  </script>
 */
Vue.use(VueAxios, axios)
Vue.use(VueLodash, {})
Vue.use(VueSweetalert2);

let registerServiceWorker = async () => {
  window.console.log('register>', window.serviceWorker)
  if ('serviceWorker' in navigator) {
    let scope = window.location.pathname // '/noq/noq-portal/'
    window.console.log(`Registrando service worker: [${scope}]`)
    window.serviceWorker = await navigator.serviceWorker.register('./sw.js', {
      scope
    });

    window.console.log('register>', window.serviceWorker)
  }
}

registerServiceWorker()

Vue.filter('iso2textdate', function(value) {
  if (value) {
    value = value.split('+')[0]
    return moment(String(value)).format('dddd LL')
  }
})

Vue.filter('iso2shortdate', function(value) {
  if (value) {
    value = value.split('+')[0]
    return moment(String(value)).format('dddd, l')
  }
})

Vue.filter('iso2time', function(value) {
  if (value) {
    return value.split('T')[1].slice(0,5)
  }
})

Vue.config.productionTip = false


// ID_ANALYTICS_CLIENTE_PRODUCCION se reemplaza en jenkinsfile
// por lo que sea. Si no se reemplaza (localhost) se elimina

let includes = [
  { id: "G-V494ZERXXF" },
  { id: "G-G73HYCNGDN" }
].filter( s => !s.id.startsWith('ID_ANALYTICS_CLIENTE'))

window.console.log('Usando los siguientes clientes de google analytics>', includes)

Vue.use(VueGtag, {
  appName: 'noQ - sistema de cita previa',
  pageTrackerScreenviewEnabled: true,
  includes
  /*
  pageTrackerTemplate(to) {
    window.console.log('pageTrackerTemplate>', to)

    let lang = Session.getLanguage() || { name: 'es' }
    let locale = lang.name
    let allPages = i18n.messages[locale].miga
    let toPageTitle = i18n.messages[locale].titulo + ' - ' + allPages[to.name].split('>').slice(-1)[0]

    window.console.log('lang>', lang)
    window.console.log('locale>', locale)
    window.console.log('$i18n>', i18n.messages)
    window.console.log('miga>', i18n.messages[locale].miga)
    window.console.log('toPageTitle>', toPageTitle)

    return {
      page_title: toPageTitle,
      page_path: to.path
    }
  }
  */
}, router);

window.vueinstance = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
